import {Params} from '@feathersjs/feathers'

import config from '../../config'

import {Provider, ProviderId} from '../../types'

import * as feathersService from '../feathers'
import httpJsonAuth from '../http-json-auth'

// For now it's only possible to patch some fields of the provider
export type ProviderRequest = {
  description?: string
  minimumProductionPrice?: number
  online?: boolean
}

export const RESOURCE = 'provider'

export const get = async (params?: Params) =>
  feathersService.find<Provider>(RESOURCE, {
    query: {
      $modify: 'includeApps',
    },
    ...params,
  })

export const getById = async (id: ProviderId) =>
  feathersService.get<Provider>(RESOURCE, id, {
    query: {
      $modify: 'includeApps',
    },
  })

export const patch = async (payload: Partial<ProviderRequest>, id: ProviderId) =>
  feathersService.patch<Provider>(RESOURCE, id, payload)

export const uploadLogo = async (payload: {file: File}, id: ProviderId) => {
  const response = await httpJsonAuth.upload({
    method: 'PATCH',
    url: `${config.services.api.baseUrl}/${RESOURCE}/${id}/logo`,
    body: payload,
  })
  return response.json
}
